import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initCspReporter } from "./lib/cspReporter";
import { initGlobalErrorLogging } from "./lib/errorLogger";
import { initHeadMetaSync } from "./lib/seo/syncHeadMeta";
import { captureFirstTouch } from "./lib/onboardingTracking";

// Onthoud de eerste pagina van deze tab (bron voor de onboarding-meting).
captureFirstTouch();

// Monitor Content-Security-Policy violations (logged to console).
initCspReporter();

// Capture uncaught errors / rejected promises (noise-filtered, throttled).
initGlobalErrorLogging();

// Keep the static description tags in index.html in sync with per-page Helmet tags.
initHeadMetaSync();

// Render app first - SW registration is deferred to avoid blocking initial paint
createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Defer service worker registration until browser is idle (improves LCP/INP)
const registerServiceWorker = () => {
  import('virtual:pwa-register').then(({ registerSW }) => {
    const updateSW = registerSW({
      onNeedRefresh() {
        updateSW(true);
      },
      onOfflineReady() {
        console.log('App ready for offline use');
      },
    });
  });
};

if (typeof window !== 'undefined') {
  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(registerServiceWorker, { timeout: 4000 });
  } else {
    setTimeout(registerServiceWorker, 3000);
  }
}
